import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const CalenderLeftIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2377 2.51094C16.4627 2.51094 16.6502 2.58594 16.8377 2.73594C17.1752 3.07344 17.1752 3.59844 16.8377 3.93594L8.9627 11.9984L16.8377 20.0234C17.1752 20.3609 17.1752 20.8859 16.8377 21.2234C16.5002 21.5609 15.9752 21.5609 15.6377 21.2234L7.1627 12.5984C6.8252 12.2609 6.8252 11.7359 7.1627 11.3984L15.6377 2.77344C15.7877 2.62344 16.0127 2.51094 16.2377 2.51094Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default CalenderLeftIconDark;
